import React from 'react';
import Tilt from 'react-tilt';
import "./Logo.css"
import LogoFaceAI from "./LogoFaceAI.png"

const Logo = () => {
    return (
        <div style={{display:"flex", justifyContent:"flex-start" }}>
            <Tilt className="Tilt br2 shadow-5" options={{ max : 25 }} style={{ height: 150, width: 150}} >
               <div className="Tilt-inner"><img className="pt3" src={LogoFaceAI} alt="AI Logo"/></div>
            </Tilt>
        </div>
    )
}
export default Logo;